export default __webpack_public_path__ + "static/media/button-collapsed.62c51621.svg";